import React from 'react'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from '@mui/material'

const DEFAULT_EXIT_PROMPT = 'Are you sure you want to exit this event?'
const DEFAULT_STAY_LABEL = 'No, Stay'
const DEFAULT_EXIT_LABEL = 'Yes, Exit'

const EventConfirmExitDialog = ({
  open,
  anearEvent,
  prompt,
  title,
  body,
  stayLabel,
  exitLabel,
  onStay,
  onExit
}) => {
  const iconUrl = anearEvent?.zone?.app?.iconUrl
  const shortName = anearEvent?.zone?.app?.shortName
  const promptText = typeof prompt === 'string' && prompt.trim().length > 0
    ? prompt.trim()
    : DEFAULT_EXIT_PROMPT
  const titleText = typeof title === 'string' && title.trim().length > 0 ? title.trim() : ''
  const bodyText = typeof body === 'string' && body.trim().length > 0 ? body.trim() : ''
  const useStructured = Boolean(titleText)
  const stayButtonLabel = typeof stayLabel === 'string' && stayLabel.trim().length > 0
    ? stayLabel.trim()
    : DEFAULT_STAY_LABEL
  const exitButtonLabel = typeof exitLabel === 'string' && exitLabel.trim().length > 0
    ? exitLabel.trim()
    : DEFAULT_EXIT_LABEL

  return (
    <Dialog
      open={open}
      onClose={(_e, _reason) => onStay?.()}
      aria-labelledby="confirm-exit-event-title"
      maxWidth="xs"
      fullWidth
    >
      <DialogContent>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
          {iconUrl && (
            <Box
              component="img"
              src={iconUrl}
              alt={shortName || 'Event'}
              sx={{
                width: '5.6rem',
                height: '5.6rem',
                objectFit: 'contain',
                flexShrink: 0,
                borderRadius: 1
              }}
            />
          )}
          <Box sx={{ minWidth: 0, flex: 1, pt: iconUrl ? 0 : 0 }}>
            {useStructured ? (
              <>
                <Typography
                  id="confirm-exit-event-title"
                  component="h2"
                  variant="h6"
                  sx={{ fontWeight: 800, mb: bodyText ? 1 : 0, lineHeight: 1.25, color: 'text.primary' }}
                >
                  {titleText}
                </Typography>
                {bodyText ? (
                  <Typography variant="body2" sx={{ color: 'text.secondary', lineHeight: 1.5 }}>
                    {bodyText}
                  </Typography>
                ) : null}
              </>
            ) : (
              <Typography id="confirm-exit-event-title" variant="h6" sx={{ fontWeight: 600 }}>
                {promptText}
              </Typography>
            )}
          </Box>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onStay} color="primary" variant="outlined" sx={{ textTransform: 'none' }}>
          {stayButtonLabel}
        </Button>
        <Button onClick={onExit} color="primary" variant="contained" sx={{ textTransform: 'none' }}>
          {exitButtonLabel}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default EventConfirmExitDialog

